import { ActionTree, GetterTree, Module, MutationTree } from 'vuex'
import { RootState, UserState, User } from '@/definitions'
import { router } from '@/router'
import * as jose from 'jose'

const state: UserState = {
  currentUser: null
}

const getters: GetterTree<UserState, unknown> = {
  currentUser: (state): User | null => state.currentUser,
  isLoggedIn: (state): boolean => state.currentUser !== null,
  hasRoles: (state) => (roles: string[]) => {
    return roles.some((role: string) => state.currentUser?.roles.includes(role))
  }
}

const mutations: MutationTree<UserState> = {
  setCurrentUser (state, user: User | null): void {
    state.currentUser = user
  }
}

const actions: ActionTree<UserState, RootState> = {
  setCurrentUser ({ commit }, user: User): void {
    commit('setCurrentUser', user)
  },
  async setCurrentUserFromToken ({ commit }, token: string): Promise<void> {
    const spki = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAzYWCgsh26Y1e7mNtwXRx
O2sgCqz//Gn3kLxnLjV55hml5mw+tZWQ3Y1Ea/KYxCXlfCcduvzO7dfMKlnWS56u
vAqr0Z9KtMTTQqXiIFJfyn6iPpPKpAEDgzd3EX1uOLl8Sh+UHfhSqLqfW1hvaD1v
b7uRchV1xqPmhjIyiiG1s7LW0mH2APSYdY6r4c9YSTnHywpwBtResj7ninw3abiJ
nEOrGap4GMPtp5DnV3ie0hciSrNIaVp4sbJRWTIt2thjBPwUWxLBv8wg2C4dkDz3
87dvIjeuO9bkaoQj/o1EutRVJandKZpSfTd9edgYCDCpOL0Zs8OvqOz8JSsbYHBF
hQIDAQAB
-----END PUBLIC KEY-----`
    const publicKey = await jose.importSPKI(spki, 'RS256')
    const { payload } = await jose.jwtVerify(token, publicKey, {
      issuer: 'locacore'
    })

    window.localStorage.setItem('LOCA_PORTAL_ACCESS_TOKEN', token)

    commit('setCurrentUser', {
      id: payload.id,
      name: payload.name,
      roles: payload.roles
    })
  },
  logout ({ commit }): void {
    commit('setCurrentUser', null)
    window.localStorage.removeItem('LOCA_PORTAL_STATE')
    window.localStorage.removeItem('LOCA_PORTAL_ACCESS_TOKEN')
    router.push({ name: 'login' })
  }
}

export const user: Module<UserState, RootState> = {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
}
